import { Button, Heading } from "@ariakit/react";
import { deleteDatabase } from "@indietabletop/appkit";
import { useState } from "react";

export function DebugPage() {
  const [wasDeleted, setDeleted] = useState(false);

  return (
    <div>
      <Heading>Debug</Heading>

      <div>
        Delete local database:
        {!wasDeleted ? (
          <Button
            onClick={async () => {
              try {
                await deleteDatabase("greathelm");
              } finally {
                setDeleted(true);
              }
            }}
          >
            Delete
          </Button>
        ) : (
          <Button
            onClick={() => {
              window.location.replace("/");
            }}
          >
            Back to app
          </Button>
        )}
      </div>
    </div>
  );
}
